<script setup>
import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="145px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>

          <el-form-item label="临时措施" prop="`suggestionItems.${index}.provisionalMeasures`">
            <el-input v-model="sItem.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>

          <el-form-item
            :prop="`suggestionItems.${index}.provisionalMeasuresFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.provisionalMeasuresFile"
            ></file-upload-list>
          </el-form-item>

          <el-form-item
            label="永久方案"
            :prop="`suggestionItems.${index}.permanentSolution`"
            :rules="rules.permanentSolution"
          >
            <el-input
              :disabled="sItem && sItem.permanentSolution !== ''"
              placeholder="请输入永久方案"
              v-model="sItem.permanentSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.permanentSolutionFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>
          <el-form-item
            label="实际断点时间"
            :prop="`suggestionItems.${index}.planBreakpointTime`"
            :rules="rules.planBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.planBreakpointTime !== ''"
              v-model="sItem.planBreakpointTime"
              type="date"
              placeholder="请选择实际断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="完成情况"
            :prop="`suggestionItems.${index}.finishStatusInfo`"
            :rules="rules.finishStatusInfo"
          >
            <el-input
              :disabled="sItem && sItem.finishStatusInfo !== ''"
              placeholder="请输入完成情况"
              v-model="sItem.finishStatusInfo"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.finishStatusInfoFiles`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.finishStatusInfoFiles"
            ></file-upload-list>
          </el-form-item>
          <el-form-item
            label="实际断点时间"
            :prop="`suggestionItems.${index}.practicalBreakpointTime`"
            :rules="rules.practicalBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.practicalBreakpointTime !== ''"
              v-model="sItem.practicalBreakpointTime"
              type="date"
              placeholder="请选择断点时间"
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
      <el-divider></el-divider>
      <el-form-item label="工厂验证情况">
        <el-input
          :disabled="taskDefKey === 'Activity_1xjhayn'"
          placeholder="请输入工厂验证情况"
          v-model="form.factoryVerificationSituation"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 4 }"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item>
        <file-upload-list
          v-if="taskDefKey === 'Activity_1xjhayn'"
          ref="fileUploadList"
          :fileList="form.factoryVerificationSituationFiles"
        ></file-upload-list>
        <drag-upload
          v-else
          ref="uploadFile"
          :accessoryList.sync="form.factoryVerificationSituationFiles"
          :httpRequest="imAction"
        />
      </el-form-item>
      <el-form-item>
        <div style="display: inline-block; margin-right: 10px">
          <el-button
            v-if="this.taskDefKey == 'Activity_0qhj6rd'"
            class="lang-but"
            type="primary"
            @click="auditPassBtClick('pass')"
            >通过</el-button
          >
          <el-button
            v-else
            class="lang-but"
            type="primary"
            @click="auditPassBtClick('close')"
            >关闭流程</el-button
          >
        </div>

        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="80px"
        >
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input
              v-model="form.rejectReason"
              type="textarea"
              placeholder="请输入驳回原因"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 23.2-质量工程师关闭
 */
export default {
  name: "kdQualityEngineerCloseAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    factoryVerificationSituation: String,
    factoryVerificationSituationFiles: {
      type: Array,
      default: () => undefined,
    },
    suggestionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      hasFileEchoShow: false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        rejectReason: "",
        factoryVerificationSituation: "",
        factoryVerificationSituationFiles: [],
        suggestionItems: [
          {
            userId: "",
            hasReasonAnalystMaterial: "",
            practicalBreakpointTime: "",
            reasonAnalyst: "",
            checkStatusInfo: "",
            checkStatusInfoFiles: [],
            provisionalMeasuresFile: [],
            reasonAnalystMaterial: "",
            planBreakpointTime: "",
            permanentSolution: "",
            permanentSolutionFile: [],
            finishStatusInfo: "",
            finishStatusInfoFiles: [],
            file: [],
          },
        ],
        auditText: "",
      },
      rules: {
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur", "change"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        finishStatusInfo: [
          {
            required: true,
            message: "完成情况不能为空",
            trigger: ["blur", "change"],
          },
        ],
        practicalBreakpointTime: [
          {
            required: true,
            message: "断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        factoryVerificationSituation: [
          {
            required: true,
            message: "工厂验证情况不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick(type) {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        factoryVerificationSituation:
          this.form.factoryVerificationSituation,
        factoryVerificationSituationFiles:
          this.form.factoryVerificationSituationFiles,
        variables: {
          approval: true,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
  mounted() {
    if (this.suggestionItems) {
      this.form.suggestionItems = this.suggestionItems;
      this.form.factoryVerificationSituationFiles =
        this.factoryVerificationSituationFiles ?? [];
      this.form.factoryVerificationSituation =
        this.factoryVerificationSituation ?? "";
    }
  },
};
</script>
